import React from 'react';
import { Navigate } from 'react-router-dom';

const AuthenticateClientRoute = ({ children }) => {
  const token = localStorage.getItem('token'); // Assuming the token is stored as 'authToken'
  // If there's no token, redirect to the admin login page
  if (!token) {
    return <Navigate to="/clientLogin" />;
  }
  // if(response.status === 401){
  //   return <Navigate to="/userLogin" />;
  // }

  // If token exists, render the requested admin page
  return children;
};

export default AuthenticateClientRoute;